import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, flex, flexAbsoluteCenter, flexDirection, mb, mr, mt, p, pv, w100} from "@pg-design/helpers-css-strings";
import {BrandRankingIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useResponsiveOpenLink} from "../../../../hooks/use_responsive_open_link";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../../../offer/types/IOfferDetail";
import {getThumbnailLink} from "../../../../utils/get_thumbnail_link";
import {clearOfferName} from "../../../utils/clear_offer_name";
import {getPositionValue} from "../../../utils/get_position_value";

interface IWinningOffersBox {
    offer: Pick<IOfferDetail, "name" | "main_image" | "main_image_url" | "address" | "id" | "slug" | "vendor">;
    position: number;
    onClick?: () => void;
}

export const WinningOffersBox = ({offer, position, onClick}: IWinningOffersBox) => {
    const offerUrl = useOfferLink({
        ...offer,
        groups: null
    });

    const openResponsiveLink = useResponsiveOpenLink(offerUrl);

    return (
        <div css={boxHolder} onClick={onClick}>
            <a href={offerUrl} target="_blank" css={imageHolder}>
                <div css={mobileHeadingHolder}>
                    <div css={placeHolderMobile}>
                        <BrandRankingIcon size="4" />

                        <Text as="span" variant="headline_6">
                            {position} miejsce
                        </Text>
                    </div>

                    <img width={390} height={256} alt={offer.name} src={getThumbnailLink(offer.main_image_url, 440, 248) ?? offer.main_image?.m_img_440x248} />
                </div>
            </a>

            <div css={boxDetailHolder} onClick={openResponsiveLink}>
                <div css={boxTextStyle}>
                    <Text as="p" mb={2} variant="headline_4" className="bt">
                        {clearOfferName(offer.name)}
                    </Text>
                    <Text as="p" variant="body_copy_1">
                        {offer.address}
                    </Text>

                    <Button variant="outlined_secondary" css={buttonStyle}>
                        Zobacz inwestycję
                    </Button>
                </div>

                <div css={placeIndicator}>
                    <BrandRankingIcon size="7.2" wrapperColor={getThemeVariable("colors.primary")} wrapperSize="7.2" />
                    <Text as="span" variant="headline_4">
                        {getPositionValue(position)} miejsce
                    </Text>
                </div>
            </div>
        </div>
    );
};

const boxHolder = css`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 33.6rem;
    background-color: #fff;
    ${borderRadius(2)};
    ${elevation(2)};
    ${mb(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex-direction: row;
        max-width: unset;
        ${w100};
        ${mb(3)};
    }
`;

const mobileHeadingHolder = css`
    ${flex()};
    ${flexDirection("column")};
`;

const boxDetailHolder = css`
    ${flex("normal", "space-between")};
    ${w100};
    cursor: pointer;
    ${p(2, 2, 4)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(4, 4, 6)};
    }
`;

const boxTextStyle = css`
    ${flex("start", "center")};
    ${flexDirection("column")};
`;

const placeIndicator = css`
    display: none;

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${flexAbsoluteCenter};
        flex-direction: column;
        ${mr(4)};
        gap: ${calculateRemSize(2)};
    }
`;

const placeHolderMobile = css`
    background-color: ${getThemeVariable("colors.primary")};
    ${flexAbsoluteCenter};
    ${pv(3)};
    gap: ${calculateRemSize(2)};
    max-height: 7.2rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        display: none;
    }
`;

const buttonStyle = css`
    ${mt(4)};
`;

const imageHolder = css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        text-decoration: none;
        color: ${getThemeVariable("colors.secondary")};
    }
`;
import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, flex, flexAbsoluteCenter, flexDirection, mb, mr, mt, p, pv, w100} from "@pg-design/helpers-css-strings";
import {BrandRankingIcon} from "@pg-design/icons-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {useResponsiveOpenLink} from "../../../../hooks/use_responsive_open_link";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../../../offer/types/IOfferDetail";
import {getThumbnailLink} from "../../../../utils/get_thumbnail_link";
import {clearOfferName} from "../../../utils/clear_offer_name";
import {getPositionValue} from "../../../utils/get_position_value";

interface IWinningOffersBox {
    offer: Pick<IOfferDetail, "name" | "main_image" | "main_image_url" | "address" | "id" | "slug" | "vendor">;
    position: number;
    onClick?: () => void;
}

export const WinningOffersBox = ({offer, position, onClick}: IWinningOffersBox) => {
    const offerUrl = useOfferLink({
        ...offer,
        groups: null
    });

    const openResponsiveLink = useResponsiveOpenLink(offerUrl);

    return (
        <div css={boxHolder} onClick={onClick}>
            <a href={offerUrl} target="_blank" css={imageHolder}>
                <div css={mobileHeadingHolder}>
                    <div css={placeHolderMobile}>
                        <BrandRankingIcon size="4" />

                        <Text as="span" variant="headline_6">
                            {position} miejsce
                        </Text>
                    </div>

                    <img width={390} height={256} alt={offer.name} src={getThumbnailLink(offer.main_image_url, 440, 248) ?? offer.main_image?.m_img_440x248} />
                </div>
            </a>

            <div css={boxDetailHolder} onClick={openResponsiveLink}>
                <div css={boxTextStyle}>
                    <Text as="p" mb={2} variant="headline_4" className="bt">
                        {clearOfferName(offer.name)}
                    </Text>
                    <Text as="p" variant="body_copy_1">
                        {offer.address}
                    </Text>

                    <Button variant="outlined_secondary" css={buttonStyle}>
                        Zobacz inwestycję
                    </Button>
                </div>

                <div css={placeIndicator}>
                    <BrandRankingIcon size="7.2" wrapperColor={getThemeVariable("colors.primary")} wrapperSize="7.2" />
                    <Text as="span" variant="headline_4">
                        {getPositionValue(position)} miejsce
                    </Text>
                </div>
            </div>
        </div>
    );
};

const boxHolder = css`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 33.6rem;
    background-color: #fff;
    ${borderRadius(2)};
    ${elevation(2)};
    ${mb(2)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex-direction: row;
        max-width: unset;
        ${w100};
        ${mb(3)};
    }
`;

const mobileHeadingHolder = css`
    ${flex()};
    ${flexDirection("column")};
`;

const boxDetailHolder = css`
    ${flex("normal", "space-between")};
    ${w100};
    cursor: pointer;
    ${p(2, 2, 4)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(4, 4, 6)};
    }
`;

const boxTextStyle = css`
    ${flex("start", "center")};
    ${flexDirection("column")};
`;

const placeIndicator = css`
    display: none;

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${flexAbsoluteCenter};
        flex-direction: column;
        ${mr(4)};
        gap: ${calculateRemSize(2)};
    }
`;

const placeHolderMobile = css`
    background-color: ${getThemeVariable("colors.primary")};
    ${flexAbsoluteCenter};
    ${pv(3)};
    gap: ${calculateRemSize(2)};
    max-height: 7.2rem;

    @media (min-width: ${getThemeBreakpoint().md}) {
        display: none;
    }
`;

const buttonStyle = css`
    ${mt(4)};
`;

const imageHolder = css`
    &:visited,
    &:hover,
    &:focus,
    &:active {
        text-decoration: none;
        color: ${getThemeVariable("colors.secondary")};
    }
`;
